import { FC, useState, useRef } from "react";
import { useMediaQuery } from "react-responsive";
import { defaultBreakpoints } from "styled-media-query";
import { SectionChildren } from "./Children.styed";
interface Props {
  children: any;
  open: boolean;
}

const Children: FC<Props> = ({ open, children }) => {
  const large = useMediaQuery({
    query: `(min-width: ${defaultBreakpoints.medium})`,
  });
  if (open) {
    return <SectionChildren>{children}</SectionChildren>;
  }
  if (large) {
    return <SectionChildren>{children}</SectionChildren>;
  } else {
    return <></>;
  }
};

export default Children;
